export type OrganizationUserActivity = {
  id?: string | null
  is_active?: boolean | null
}

export const isActiveOrganizationUser = (
  user: OrganizationUserActivity | null | undefined,
): boolean => user?.is_active !== false

export const filterActiveOrganizationUsers = <T extends OrganizationUserActivity>(
  users: T[] | null | undefined,
): T[] => (users ?? []).filter((user) => Boolean(user?.id) && isActiveOrganizationUser(user))

export const filterSelectableOrganizationUsers = <T extends OrganizationUserActivity>(
  users: T[] | null | undefined,
  allowedEmployeeIds?: string[] | null,
): T[] => {
  const allowed = Array.isArray(allowedEmployeeIds)
    ? new Set(allowedEmployeeIds.map(String).filter(Boolean))
    : null

  return filterActiveOrganizationUsers(users).filter(
    (user) => !allowed || allowed.has(String(user.id)),
  )
}
